import React, { useState ,useEffect} from 'react';
import {
  Container,
  Typography,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  Button,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const PrenatalHistory = () => {
  const [formData, setFormData] = useState({
    // Demographic Information
    opNumber: '', // Changed from ipNo to opNo
    date: '',
    husbandName: '', // Changed from fatherName
    husbandAge: '', // Changed from fatherAge
    husbandEducation: '', // Changed from fatherEducation
    husbandOccupation: '', // Changed from fatherOccupation
    clientName: '', // Changed from motherName
    clientAge: '', // Changed from motherAge
    clientEducation: '', // Changed from motherEducation
    clientOccupation: '', // Changed from motherOccupation
    address: '',
    phoneNo: '',
    consanguinity: 'No',
    relationship: '',
    socioEconomicStatus: 'Middle',
    familyNature: 'Nuclear',
    location: 'Urban',

    // Sibling History
    birthAt: 'Hospital',
    childAge: '',
    childSex: 'Male',
    siblings: '',
    term: 'Full term',
    pretermReason: '',
    siblingDisorders: '', // Added for sibling disorders

    // Family Background
    speechProblems: 'No',
    speechProblemsSpecify: '', // Added textbox for specification
    hearingImpairment: 'No',
    hearingImpairmentSpecify: '', // Added textbox for specification
    mentalRetardation: 'No',
    mentalRetardationSpecify: '', // Added textbox for specification
    neurologicalDisorders: 'No',
    neurologicalDisordersSpecify: '', // Added textbox for specification
    congenitalDefects: 'No',
    congenitalDefectsSpecify: '', // Added textbox for specification
    physicalDefects: 'No',
    physicalDefectsSpecify: '',
    siblingHistory: 'No',
    others: '',

    // Prenatal History
    diabetesHistory: 'No',
    abnormalBpHistory: 'No',
    excessiveVomiting: '',
    pregnancyAge: '',
    abortions: '',
    ototoxicMedication: 'No',
    radiationExposure: 'No',
    radiationExposureTimes: '',
    rhIncompatibility: '',
    infection: '',
    infectionOthers: '',
    alcoholSmoking: 'No',
    otherComplications: '',
    otherRelevantFindings: '',
    fetalMovementsPerDay: '', // Added: No of fetal movements per day
    soundExposureMovements: '', // Added: No of movements per day for sound exposure
    counsellingDone: 'No', // Added: Counselling done
    counsellingDetails: '' // Added: Counselling details
  });
  const [demographyData, setDemographyData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [password, setPassword] = useState('');
    const [downloadFormat, setDownloadFormat] = useState('excel');
  const infectionOptions = [
    'TORCH',
    'Mumps',
    'Measles',
    'Rubella',
    'Cytomegalovirus',
    'Herpes',
    'Varicella',
    'Others'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const data = localStorage.getItem("demography");
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        
        // Set patient number based on available data
        let patientNumber = '';
        if (parsedData.ipNumber) patientNumber = `IP: ${parsedData.ipNumber}`;
        else if (parsedData.opNumber) patientNumber = `OP: ${parsedData.opNumber}`;
        else if (parsedData.internalNumber) patientNumber = `Internal: ${parsedData.internalNumber}`;
        
        // Set the demographyData with the patientNumber
        setDemographyData({ ...parsedData, patientNumber });
      } catch (error) {
        console.error("Error parsing demography data:", error);
      }
    }
  }, []);
 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/prenatal-history`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
        // Patient information
          patientName: demographyData.name,
          patientNumber: demographyData.patientNumber,
          patientIpNumber: demographyData.ipNumber || '',
          patientOpNumber: demographyData.opNumber || '',
          patientInternalNumber: demographyData.internalNumber || '',
    });

      if (response.ok) {
        alert('Form submitted successfully!');
         setFormData({
        opNumber: '',
        date: '',
        husbandName: '',
        husbandAge: '',
        husbandEducation: '',
        husbandOccupation: '',
        clientName: '',
        clientAge: '',
        clientEducation: '',
        clientOccupation: '',
        address: '',
        phoneNo: '',
        consanguinity: 'No',
        relationship: '',
        socioEconomicStatus: 'Middle',
        familyNature: 'Nuclear',
        location: 'Urban',

        // Sibling History
        birthAt: 'Hospital',
        childAge: '',
        childSex: 'Male',
        siblings: '',
        term: 'Full term',
        pretermReason: '',
        siblingDisorders: '',

        // Family Background
        speechProblems: 'No',
        speechProblemsSpecify: '',
        hearingImpairment: 'No',
        hearingImpairmentSpecify: '',
        mentalRetardation: 'No',
        mentalRetardationSpecify: '',
        neurologicalDisorders: 'No',
        neurologicalDisordersSpecify: '',
        congenitalDefects: 'No',
        congenitalDefectsSpecify: '',
        physicalDefects: 'No',
        physicalDefectsSpecify: '',
        siblingHistory: 'No',
        others: '',

        // Prenatal History
        diabetesHistory: 'No',
        abnormalBpHistory: 'No',
        excessiveVomiting: '',
        pregnancyAge: '',
        abortions: '',
        ototoxicMedication: 'No',
        radiationExposure: 'No',
        radiationExposureTimes: '',
        rhIncompatibility: '',
        infection: '',
        infectionOthers: '',
        alcoholSmoking: 'No',
        otherComplications: '',
        otherRelevantFindings: '',
        fetalMovementsPerDay: '',
        soundExposureMovements: '',
        counsellingDone: 'No',
        counsellingDetails: ''
      });
      } else {
        alert('Error submitting form');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error submitting form');
    }
  };
 if (!demographyData) return <div>Loading...</div>;

 const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Prenatal History ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "prenatal_history",
          formName: "Prenatal_History",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Prenatal_History_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };
  return (
    <Box sx={{ padding: 3, backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
           <Box sx={{ position: 'absolute', top: 350, right: 70 }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}
              >
                Download 
              </Button>
            </Box>
      <Container maxWidth="md">
        <Paper
          sx={{
            padding: 3,
            marginBottom: 3,
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            backgroundColor: 'white',
          }}
        >
          <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
            Prenatal History Form
          </Typography>
  {/* Patient Info */}
      <Typography variant="h5" gutterBottom fontWeight="bold" color="primary">
        Patient Information
      </Typography>
      <Grid container spacing={2} mb={4}>
        <Grid item xs={12} sm={6}>
          <Typography><strong>Name:</strong> {demographyData.name}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography><strong>Age:</strong> {demographyData.age}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography><strong>Gender:</strong> {demographyData.gender}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography><strong>Phone:</strong> {demographyData.phone}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography><strong>Address:</strong> {demographyData.address}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography><strong>Referred by:</strong> {demographyData.referredBy}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography><strong>Patient ip_number:</strong> {demographyData.patientNumber}</Typography>
        </Grid>
      </Grid>
          <form onSubmit={handleSubmit}>
            {/* Demographic Information Section */}
            <Paper
              sx={{
                padding: 3,
                marginBottom: 3,
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  marginBottom: 2,
                  paddingBottom: 1,
                  borderBottom: '2px solid #3f51b5',
                  color: '#3f51b5',
                }}
              >
                Demographic Information
              </Typography>

              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Field</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>OP Number</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="opNumber"
                          value={formData.opNumber}
                          onChange={handleChange}
                          fullWidth
                          required
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>
                        <TextField
                          type="date"
                          size="small"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Husband's Name</TableCell> {/* Changed from Father */}
                      <TableCell>
                        <TextField
                          size="small"
                          name="husbandName"
                          value={formData.husbandName}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Husband's Age</TableCell> {/* Changed from Father */}
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          name="husbandAge"
                          value={formData.husbandAge}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Husband's Education</TableCell> {/* Changed from Father */}
                      <TableCell>
                        <TextField
                          size="small"
                          name="husbandEducation"
                          value={formData.husbandEducation}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Husband's Occupation</TableCell> {/* Changed from Father */}
                      <TableCell>
                        <TextField
                          size="small"
                          name="husbandOccupation"
                          value={formData.husbandOccupation}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Client's Name</TableCell> {/* Changed from Mother */}
                      <TableCell>
                        <TextField
                          size="small"
                          name="clientName"
                          value={formData.clientName}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Client's Age</TableCell> {/* Changed from Mother */}
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          name="clientAge"
                          value={formData.clientAge}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Client's Education</TableCell> {/* Changed from Mother */}
                      <TableCell>
                        <TextField
                          size="small"
                          name="clientEducation"
                          value={formData.clientEducation}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Client's Occupation</TableCell> {/* Changed from Mother */}
                      <TableCell>
                        <TextField
                          size="small"
                          name="clientOccupation"
                          value={formData.clientOccupation}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Address</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          fullWidth
                          multiline
                          rows={2}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Phone No</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="phoneNo"
                          value={formData.phoneNo}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Consanguinity</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="consanguinity"
                          value={formData.consanguinity}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    {formData.consanguinity === 'Yes' && (
                      <TableRow>
                        <TableCell>Relationship</TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            name="relationship"
                            value={formData.relationship}
                            onChange={handleChange}
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell>Socio Economic Status</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="socioEconomicStatus"
                            value={formData.socioEconomicStatus}
                            onChange={handleChange}
                          >
                            <MenuItem value="Low">Low</MenuItem>
                            <MenuItem value="Middle">Middle</MenuItem>
                            <MenuItem value="High">High</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Nature of Family</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="familyNature"
                            value={formData.familyNature}
                            onChange={handleChange}
                          >
                            <MenuItem value="Joint">Joint</MenuItem>
                            <MenuItem value="Nuclear">Nuclear</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Location</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                          >
                            <MenuItem value="Rural">Rural</MenuItem>
                            <MenuItem value="Urban">Urban</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {/* Sibling History Section */}
            <Paper
              sx={{
                padding: 3,
                marginBottom: 3,
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  marginBottom: 2,
                  paddingBottom: 1,
                  borderBottom: '2px solid #3f51b5',
                  color: '#3f51b5',
                }}
              >
                Sibling History
              </Typography>

              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Field</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Age of Child</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="childAge"
                          value={formData.childAge}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Sex of Child</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="childSex"
                            value={formData.childSex}
                            onChange={handleChange}
                          >
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Birth At</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="birthAt"
                            value={formData.birthAt}
                            onChange={handleChange}
                          >
                            <MenuItem value="Hospital">Hospital</MenuItem>
                            <MenuItem value="Nursing home">Nursing home</MenuItem>
                            <MenuItem value="Home">Home</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Term</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="term"
                            value={formData.term}
                            onChange={handleChange}
                          >
                            <MenuItem value="Full term">Full term</MenuItem>
                            <MenuItem value="Pre term">Pre term</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    {formData.term === 'Pre term' && (
                      <TableRow>
                        <TableCell>Reason for Pre-term</TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            name="pretermReason"
                            value={formData.pretermReason}
                            onChange={handleChange}
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell>Presence of Any Disorder</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="siblingDisorders"
                          value={formData.siblingDisorders}
                          onChange={handleChange}
                          fullWidth
                          multiline
                          rows={2}
                          placeholder="Specify disorders if any"
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {/* Family Background Section */}
            <Paper
              sx={{
                padding: 3,
                marginBottom: 3,
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  marginBottom: 2,
                  paddingBottom: 1,
                  borderBottom: '2px solid #3f51b5',
                  color: '#3f51b5',
                }}
              >
                Family Background History
              </Typography>

              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Field</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Speech Problems</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="speechProblems"
                          value={formData.speechProblems}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formData.speechProblems === 'Yes' && (
                          <TextField
                            size="small"
                            name="speechProblemsSpecify"
                            value={formData.speechProblemsSpecify}
                            onChange={handleChange}
                            fullWidth
                            placeholder="Specify speech problems"
                            sx={{ mt: 1 }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Hearing Impairment</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="hearingImpairment"
                          value={formData.hearingImpairment}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formData.hearingImpairment === 'Yes' && (
                          <TextField
                            size="small"
                            name="hearingImpairmentSpecify"
                            value={formData.hearingImpairmentSpecify}
                            onChange={handleChange}
                            fullWidth
                            placeholder="Specify hearing impairment"
                            sx={{ mt: 1 }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Mental Retardation</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="mentalRetardation"
                          value={formData.mentalRetardation}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formData.mentalRetardation === 'Yes' && (
                          <TextField
                            size="small"
                            name="mentalRetardationSpecify"
                            value={formData.mentalRetardationSpecify}
                            onChange={handleChange}
                            fullWidth
                            placeholder="Specify mental retardation"
                            sx={{ mt: 1 }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Neurological Disorders</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="neurologicalDisorders"
                          value={formData.neurologicalDisorders}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formData.neurologicalDisorders === 'Yes' && (
                          <TextField
                            size="small"
                            name="neurologicalDisordersSpecify"
                            value={formData.neurologicalDisordersSpecify}
                            onChange={handleChange}
                            fullWidth
                            placeholder="Specify neurological disorders"
                            sx={{ mt: 1 }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Congenital Defects</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="congenitalDefects"
                          value={formData.congenitalDefects}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formData.congenitalDefects === 'Yes' && (
                          <TextField
                            size="small"
                            name="congenitalDefectsSpecify"
                            value={formData.congenitalDefectsSpecify}
                            onChange={handleChange}
                            fullWidth
                            placeholder="Specify congenital defects"
                            sx={{ mt: 1 }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Physical Defects</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="physicalDefects"
                          value={formData.physicalDefects}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formData.physicalDefects === 'Yes' && (
                          <TextField
                            size="small"
                            name="physicalDefectsSpecify"
                            value={formData.physicalDefectsSpecify}
                            onChange={handleChange}
                            fullWidth
                            placeholder="Specify physical defects"
                            sx={{ mt: 1 }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Sibling History</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="siblingHistory"
                          value={formData.siblingHistory}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Others</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="others"
                          value={formData.others}
                          onChange={handleChange}
                          fullWidth
                          multiline
                          rows={2}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {/* Prenatal History Section */}
            <Paper
              sx={{
                padding: 3,
                marginBottom: 3,
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  marginBottom: 2,
                  paddingBottom: 1,
                  borderBottom: '2px solid #3f51b5',
                  color: '#3f51b5',
                }}
              >
                Prenatal History
              </Typography>

              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Field</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>History of Diabetes</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="diabetesHistory"
                          value={formData.diabetesHistory}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>History of Abnormal Blood Pressure</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="abnormalBpHistory"
                          value={formData.abnormalBpHistory}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Excessive Vomiting</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="excessiveVomiting"
                          value={formData.excessiveVomiting}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Age of Pregnancy</TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          name="pregnancyAge"
                          value={formData.pregnancyAge}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>History of Abortions</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="abortions"
                          value={formData.abortions}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Ototoxic Medication</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="ototoxicMedication"
                          value={formData.ototoxicMedication}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Exposure to Radiation/Chemical Fumes</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="radiationExposure"
                          value={formData.radiationExposure}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    {formData.radiationExposure === 'Yes' && (
                      <TableRow>
                        <TableCell>No of Times Exposed</TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            name="radiationExposureTimes"
                            value={formData.radiationExposureTimes}
                            onChange={handleChange}
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell>Rh Incompatibility</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="rhIncompatibility"
                            value={formData.rhIncompatibility}
                            onChange={handleChange}
                          >
                            <MenuItem value="Positive">Positive</MenuItem>
                            <MenuItem value="Negative">Negative</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Viral/Bacterial Infection</TableCell>
                      <TableCell>
                        <FormControl fullWidth>
                          <Select
                            size="small"
                            name="infection"
                            value={formData.infection}
                            onChange={handleChange}
                          >
                            {infectionOptions.map((option, index) => (
                              <MenuItem key={index} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    {formData.infection === 'Others' && (
                      <TableRow>
                        <TableCell>Specify Other Infection</TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            name="infectionOthers"
                            value={formData.infectionOthers}
                            onChange={handleChange}
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell>Alcohol Consumption/Smoking</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="alcoholSmoking"
                          value={formData.alcoholSmoking}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Other Complications and Treatment</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="otherComplications"
                          value={formData.otherComplications}
                          onChange={handleChange}
                          fullWidth
                          multiline
                          rows={3}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Other Relevant Findings</TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          name="otherRelevantFindings"
                          value={formData.otherRelevantFindings}
                          onChange={handleChange}
                          fullWidth
                          multiline
                          rows={3}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>No of fetal movements per day</TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          name="fetalMovementsPerDay"
                          value={formData.fetalMovementsPerDay}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>No of movements per day for sound exposure</TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          name="soundExposureMovements"
                          value={formData.soundExposureMovements}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Counselling done</TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          name="counsellingDone"
                          value={formData.counsellingDone}
                          onChange={handleChange}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formData.counsellingDone === 'Yes' && (
                          <TextField
                            size="small"
                            name="counsellingDetails"
                            value={formData.counsellingDetails}
                            onChange={handleChange}
                            fullWidth
                            multiline
                            rows={3}
                            placeholder="Provide counselling details"
                            sx={{ mt: 1 }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
            <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              sx={{ marginTop: 2, padding: 1.5, fontSize: '1rem', width: '100%' }}
            >
              Submit
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrenatalHistory; 